<template>
    <div class="container_food_list">
        <section :class="['food_list food_seccion', {'active': sectionActive === i.id}]" v-for="(i, idx) in listMain" :key="idx" :id="'section-'+i.id" :data-row="i.id">
            <!-- <edit-category-name :indicador="i.id" :cat="i"></edit-category-name> -->
            <draggable v-model="i.foods" tag="div" v-bind="dragOptions" @change="checkMove(i.foods)" @start="isDragging = true" @end="isDragging = false" handle=".handle">
                <article class="food_item_container" v-for="(f, index) in i.foods" :key="index" :data-indicador="i.id">
                    <div class="handle"><i class="fas fa-arrows-alt-v"></i></div>
                    <div class="food_item" :data-indicador="i.id">
                        <header class="food_item_header" :data-indicador="i.id">
                            <edit-food-name :indicador="i.id" :food="f"></edit-food-name>
                            <!-- <h4 class="food_item_name" :data-indicador="i.id">{{f.name_food}}</h4> -->
                            <slider-media :indicador="i.id" :gallery="f.gallery" :urlMedia="urlMedia" @editGallery="$emit('clickAction', $event)" :foodItem="f" @clickNav="goToSlide($event)"></slider-media>
                            <button class="btn btn-danger btnDelFood" title="Delete Food"  @click="$emit('delFood', f)"><i class="fas fa-trash"></i></button>
                        </header>
                        <edit-food-details :indicador="i.id" :food="f"></edit-food-details>
                        <edit-food-price :indicador="i.id" :food="f"></edit-food-price>
                    </div>
                </article>
            </draggable>
            <div class="add_food_new text-center">
                <button class="btn btn-primary btn-xs" @click.prevent="addFood(i)" :disabled="loadSave"><i class="fas fa-chevron-up"></i> + New Item</button>
            </div>
        </section>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import draggable from 'vuedraggable'
import foodCategory from "./foodCategory.vue"
import foodEditName from "./foodEditName.vue"
import foodEditPrice from "./foodEditPrice.vue"
import foodEditDescription from "./foodEditDescription.vue"
import foodSlider from "./foodSlider.vue"
export default {
    props: ['urlMedia', 'sectionActive'],
    components: {
        draggable,
        'edit-category-name': foodCategory,
        'edit-food-name': foodEditName,
        'edit-food-price': foodEditPrice,
        'edit-food-details': foodEditDescription,
        'slider-media': foodSlider,
    },
    data(){
        return {
            apis: null,
            coordenadas: null,
            currentCoord: null,
            scrollingValue: 0,
            coordIndex: 0,
            listMain: [],
            playVideo: false,
            loadSave: false,
            details: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Quia provident eum iusto! Eveniet, reprehenderit quod. Eaque unde fuga dicta necessitatibus! Corrupti odio tempore totam ratione nulla eius velit provident porro',
            currentSlider: null,
        };
    },
    created() {
        let t = this;
        let urlApis = this.$store.getters['ModApps/Marketea/urlApis'];
        this.apis = urlApis.bMenu;
        t.listMain = t.$store.getters['ModApps/Marketea/get_bmenu_listCat'];
    },
    beforeDestroy() {
    },
    computed: {
        ...mapGetters("ModApps/Marketea/", {
            getListCat: "get_bmenu_listCat",
            getCatActive: "get_bmenu_catActive",
        }),
        dragOptions() {
            return {
                animation: 200,
                group: "gallery",
                disabled: false,
                ghostClass: "ghost",
            };
        },
    },
    watch: {
        getListCat: function(newVal, oldVal){
            let t = this;
            t.updateList(newVal);
        },
    },
    mounted(){
        this.startSlider();
    },
    methods: {
        updateList(list){
            this.listMain = list;
            this.startSlider();
        },
        startSlider() {
            this.$nextTick(() => {
                const sliders = document.querySelectorAll('.food_gallery_slider');
                if (!sliders.length) return;
                // console.log('Initializing sliders', sliders);
                sliders.forEach(slider => this.sliderEvent(slider));
            });
        },
        sliderEvent(slider) {
            if (!slider) return;
            const sliderId = slider.dataset.slider;
            const slides = slider.querySelectorAll('ul li');
            const navItems = document.querySelectorAll(
                `#food_item_content_media_${sliderId} a[class^="nav-item"]`
            ) || [];
            let isDragging = false;
            let startX = 0;
            let scrollStart = 0;
            let activeIndex = 0;
            let ticking = false;
            slider.style.maxHeight = 'min(600px, 80vh)';
            slider.style.cursor = 'grab';
            /* ------------------------------
            DRAG
            ------------------------------ */
            const onPointerDown = (e) => {
                isDragging = true;
                slider.setPointerCapture(e.pointerId);
                startX = e.clientX;
                scrollStart = slider.scrollLeft;
                slider.classList.add('dragging');
                slider.style.userSelect = 'none';
            };
            const onPointerMove = (e) => {
                if (!isDragging) return;
                const dx = e.clientX - startX;
                slider.scrollLeft = scrollStart - dx * 1.2;
            };
            const onPointerUp = (e) => {
                isDragging = false;
                try { slider.releasePointerCapture(e.pointerId); } catch (err) {}
                slider.classList.remove('dragging');
                slider.style.userSelect = '';
            };
            slider.addEventListener('pointerdown', onPointerDown);
            slider.addEventListener('pointermove', onPointerMove);
            slider.addEventListener('pointerup', onPointerUp);
            slider.addEventListener('pointerleave', onPointerUp);
            /* ------------------------------
            ACTIVE SLIDE
            ------------------------------ */
            const updateActiveSlide = () => {
                const sliderRect = slider.getBoundingClientRect();
                let closest = null;
                let closestOffset = Infinity;
                slides.forEach((slide, index) => {
                    const rect = slide.getBoundingClientRect();
                    const offset = Math.abs(rect.left - sliderRect.left);
                    if (offset < closestOffset) {
                        closestOffset = offset;
                        closest = slide;
                        activeIndex = index;
                    }
                });
                slides.forEach(s => s.classList.remove('active'));
                navItems.forEach(n => n.classList.remove('active'));
                if (closest) {
                    closest.classList.add('active');
                    if (navItems[activeIndex]) {
                        navItems[activeIndex].classList.add('active');
                    }
                }
                detectRatio();
            };
            slider.addEventListener('scroll', () => {
                if (!ticking) {
                    window.requestAnimationFrame(() => {
                        updateActiveSlide();
                        ticking = false;
                    });
                    ticking = true;
                }
            });
            /* ------------------------------
            ASPECT RATIO DINÁMICO
            ------------------------------ */
            function detectRatio() {
                // Use the active slide if available (set by updateActiveSlide), fallback to first
                const activeSlide = slider.querySelector('li.active') || slider.querySelector('li');
                if (!activeSlide) return;
                const media = activeSlide.querySelector('img, video');
                if (!media) return;

                const applyRatio = (width, height) => {
                    const ratio = width / height;
                    // Limitar proporciones extremas
                    const minRatio = 0.6;  // muy vertical
                    const maxRatio = 1.8;  // muy horizontal
                    const safeRatio = Math.min(Math.max(ratio, minRatio), maxRatio);
                    slider.style.aspectRatio = safeRatio;
                    slider.style.maxHeight = 'min(520px, 80vh)';
                    // Update helper classes for styling variants
                    slider.classList.remove('ratio-vertical', 'ratio-horizontal', 'ratio-square');
                    if (safeRatio <= 0.9) slider.classList.add('ratio-vertical');
                    else if (safeRatio >= 1.3) slider.classList.add('ratio-horizontal');
                    else slider.classList.add('ratio-square');
                };

                const handleImage = () => applyRatio(media.naturalWidth, media.naturalHeight);
                const handleVideo = () => applyRatio(media.videoWidth, media.videoHeight);

                if (media.tagName === 'IMG') {
                    if (media.complete && media.naturalWidth && media.naturalHeight) {
                        handleImage();
                    } else {
                        media.addEventListener('load', handleImage, { once: true });
                    }
                } else if (media.tagName === 'VIDEO') {
                    if (media.readyState >= 1 && media.videoWidth && media.videoHeight) {
                        handleVideo();
                    } else {
                        media.addEventListener('loadedmetadata', handleVideo, { once: true });
                    }
                }
            }
            detectRatio();
            window.addEventListener('resize', detectRatio);
            /* ------------------------------
            INIT
            ------------------------------ */
            updateActiveSlide();
        },
        goToSlide(event){
            // Resolve indicador (slider identifier)
            const indicador = event && (event.indicador ?? event.indicator ?? null);
            // Locate slider by data-slider attribute first, fallback to id
            this.currentSlider = null;
            if (indicador !== null) {
                this.currentSlider = document.querySelector(`.food_gallery_slider[data-slider="${indicador}"]`) ||
                document.querySelector(`#food_gallery_slider${indicador}`);
            }
            const slides = this.currentSlider.querySelectorAll('ul li');
            if(!slides || !slides.length) return;
            // Determine requested slide target. `SliderId` coming from the child is the gallery item id,
            // not the zero-based index. We must resolve it to the slide index.
            let index = 0;
            if (typeof event === 'number') index = event;
            else if (event && (event.SliderId != null)) {
                // find slide whose data-itemg equals SliderId
                const targetId = String(event.SliderId);
                let foundIndex = -1;
                slides.forEach((s, idx) => {
                    const itemg = s.dataset.itemg ?? s.getAttribute('data-itemg') ?? s.id ?? '';
                    if (String(itemg) === targetId) foundIndex = idx;
                });
                if (foundIndex !== -1) index = foundIndex;
                else index = Number(event.SliderId) || 0; // fallback if SliderId was actually an index
            }
            else if (event && (event.sliderId != null)) index = Number(event.sliderId);
            else if (event && (event.index != null)) index = Number(event.index);
            if(!this.currentSlider) {
                console.warn('goToSlide: slider not found for indicador', indicador);
                return;
            }
            // Clamp index within bounds
            const clamped = Math.max(0, Math.min(index, slides.length - 1));
            const target = slides[clamped];
            if (!target) return;
            // Calculate exact left using offsetLeft of the target slide
            let left = target.offsetLeft;
            // Ensure we don't exceed maximum scrollable area
            const maxLeft = this.currentSlider.scrollWidth - this.currentSlider.clientWidth;
            if (left > maxLeft) left = maxLeft;
            console.log('goToSlide', {index, clamped, left, maxLeft});
            this.currentSlider.scrollTo({ left, behavior: 'smooth' });
        },
        addFood(i){
            let t= this;
            let urlService = t.apis.set(3)// setFood
            if(!t.loadSave){
                t.loadSave = true;
                // @ts-ignore
                window.master.post(urlService, {
                    user_id: window.master_client,
                    org_id: window.localorgdata,
                    pusher_id: pusher.connection.socket_id,
                    cat_id: i.id,
                    name_food: 'Food name',
                    desc_food: t.details,
                    price: '0',
                })
                .then((response) => {
                    console.log(urlService, response.data);
                    t.loadSave = false;
                    if(response.data.status && response.data.get){
                        t.$store.commit('ModApps/Marketea/set_bMenuAddFood', response.data.get);
                    }
                })
                .catch((error) => {
                    console.log(error);
                    t.loadSave = false;
                    t.$notify({
                        group: "noti",
                        type: "error",
                        title: "Error",
                        text: "Could not be save!",
                    });
                });
            }
        },
        checkMove(foods) {
            let t = this;
            foods.map((item, index) => {
                item.orden = index;
            });
            console.log('move foods', foods)
            let urlService = t.apis.set(4)// setFoodOrden
            window.master.post(urlService, {
                ordenFoods: foods,
            })
            .then((response) => {
                console.log(response.data);
            })
            .catch((error) => {
                console.log(error);
                t.$notify({
                    group: "noti",
                    type: "error",
                    title: "Error",
                    text: "Could not be saved!",
                });
            });
        },
        ellipsisJS (textString, lengthMax) {
            let a= textString.split(' '); // texto como array
            let s =''; // resultado
            let n=0;// contador
            while(s.length < lengthMax) {
                s+=''+a[n]; n++;
                // console.log(s)
            }
            return s.replace(/\W*\s(\S)*$/, '...');
        },
    },
}
</script>
<style lang="scss" scoped>
</style>
